import { ApiProperty } from '@nestjs/swagger';
import { OptionInterface } from '../interfaces/option.interface';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { IsEnum, IsString, MaxLength, MinLength } from 'class-validator';
import { Exclude, Expose } from 'class-transformer';
import { OptionTypeEnum } from '../enum/optionType.enum';
import { JobOptionDto } from '../../job-option/dto/job-option.dto';

@Exclude()
export class OptionDto extends CommonEntityDto implements OptionInterface {
  @ApiProperty({
    type: 'enum',
    enum: OptionTypeEnum,
    title: 'Phase Type',
    description: 'The type of this Phase',
  })
  @IsEnum(OptionTypeEnum)
  @Expose()
  optionType!: OptionTypeEnum;

  @ApiProperty({
    title: 'Is Internal flag',
    description: 'Is Internal flag',
  })
  @Expose()
  isInternal!: boolean;

  @ApiProperty({
    title: 'Is Builder flag',
    description: 'Is Builder flag',
  })
  @Expose()
  isBuilder!: boolean;

  @ApiProperty({
    title: 'Name',
    description: 'The name of the Option',
  })
  @Expose()
  name!: string;

  @ApiProperty({
    title: 'Description',
    description: 'The description of the Option',
  })
  @IsString()
  @MinLength(1)
  @MaxLength(500)
  @Expose()
  description!: string;

  @ApiProperty({ type: () => [JobOptionDto], required: false })
  @Expose()
  jobOptions?: JobOptionDto[];
}
